/**
 * Google 登录配置（仅 Client ID 可在前端使用）
 * Client Secret 见项目根目录 .env.local 的 GOOGLE_CLIENT_SECRET，须配置在后端 Laravel .env
 */
export const GOOGLE_CLIENT_ID =
  process.env.VUE_APP_GOOGLE_CLIENT_ID ||
  "317320225436-m0ukrfc759miu1rai2dv5lq6bc5te2mc.apps.googleusercontent.com";
